import React from "react";
import PropTypes from "prop-types";
import Headline from "../Headline";
import WidgetCard from "../Cards/WidgetCard";
import * as S from "./CardsList.Style";

const CardsList = ({ title, subtitle, path }) => {
  return (
    <>
      <S.TipoSeguroCard
        as={WidgetCard}
        header={
          <>
            <Headline as="3" styleAs="8">
              {title}
            </Headline>
            {subtitle}
          </>
        }
      >
        <S.NavigationLinkItemStyled href={path}>
          <S.NavigationCardItemStyled>
            <S.BodyLabelLink
              textType="button"
              reset={{ marginBottom: "0px" }}
              text="Confira agora"
            />
            <S.CardIcon />
          </S.NavigationCardItemStyled>
        </S.NavigationLinkItemStyled>
      </S.TipoSeguroCard>
    </>
  );
};

CardsList.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  path: PropTypes.string.isRequired,
};

export default CardsList;
